import React, { useEffect } from 'react';
import styles from './Modal.module.css';
import ModalCloseBadge from './ModalCloseBadge';
import CloseButton from '../closeButton';
import SubmitButton from '../submitButton';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import { noScroll, removeNoScroll } from '@/actions/Helper';

const Modal = ({
  show,
  setShow,
  submit,
  submitText,
  children,
  icon,
  description,
  title,
  loadingbutton,
  notClose = false,
  preventBackdropClose = false,
  rightContent = null,
  noX = false,
  minWidth = 600,
  modalWidth = null,
  titleColor,
  customHandleClose,
  buttonPosition = 'center',
  maxHeight = null,
  maxHeightModal = null,
  cancelText = 'No, later',
  submitDisabled = false,
  manageScroll = true,
  overlayZIndex,
  childContainerStyle = null,
}) => {
  const shouldHideCloseX = noX || notClose;
  const handleClose = () => {
    setShow(false);
    if (manageScroll) {
      removeNoScroll();
    }
    if (customHandleClose) {
      customHandleClose();
    }
  };
  useEffect(() => {
    if (!manageScroll) return;
    if (show) {
      noScroll();
    }
    if (!show) {
      removeNoScroll();
    }
  }, [show, manageScroll]);
  const backdropClick = (e) => {
    if (notClose || preventBackdropClose) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      handleClose();
    }
  };
  if (!show) return null;

  const modalBoxStyle = {
    boxSizing: 'border-box',
    flexShrink: 0,
    ...(maxHeightModal != null ? { maxHeight: maxHeightModal } : {}),
  };
  if (modalWidth != null) {
    const w =
      typeof modalWidth === 'number' ? `${modalWidth}px` : String(modalWidth);
    modalBoxStyle.width = `min(${w}, 100%)`;
    modalBoxStyle.minWidth = `min(${w}, 100%)`;
    modalBoxStyle.maxWidth = '100%';
  } else {
    modalBoxStyle.minWidth = minWidth;
  }

  return (
    <div
      className={styles.backdrop}
      style={overlayZIndex != null ? { zIndex: overlayZIndex } : undefined}
      onClick={(e) => backdropClick(e)}>
      <div
        className={styles.modal}
        style={modalBoxStyle}
        onClick={(e) => e.stopPropagation()}>
        <ModalCloseBadge onClose={handleClose} />

        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <div className={styles.innerHeader}>
              <ReactSVG
                src={Icons[icon]}
                className={styles.icon}
                beforeInjection={(svg) => {
                  svg.querySelectorAll('path').forEach((path) => {
                    path.setAttribute(
                      'stroke',
                      titleColor
                        ? titleColor
                        : submitText
                        ? '#FB3748'
                        : '#131517'
                    );
                  });
                }}
              />
              <span
                style={{
                  color: titleColor
                    ? titleColor
                    : submitText
                    ? '#FB3748'
                    : '#131517',
                }}>
                {title}
              </span>
            </div>
            {rightContent && rightContent}
          </div>
        </div>
        {description && <div className={styles.description}>{description}</div>}
        <div
          className={styles.childContainer}
          style={{
            ...(maxHeight ? { maxHeight } : {}),
            ...(childContainerStyle && typeof childContainerStyle === 'object'
              ? childContainerStyle
              : {}),
          }}>
          {children}
        </div>
        {submitText && (
          <div
            className={styles.modalButtons}
            style={{
              justifyContent: buttonPosition,
            }}>
            <CloseButton onClick={handleClose} text={cancelText} />
            <SubmitButton
              text={submitText}
              onClick={submit}
              disable={submitDisabled || !!loadingbutton}
              loading={loadingbutton}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
